import { createFileRoute, redirect } from "@tanstack/react-router";

// Pendaftaran email+password sudah dimatikan; satu-satunya jalan masuk adalah
// Google OAuth di /signin. Rute ini dipertahankan hanya supaya tautan lama
// (termasuk /signup?invite=...) tidak 404.
export const Route = createFileRoute("/signup")({
	beforeLoad: () => {
		throw redirect({
			to: "/signin",
			search: { redirect: undefined, error: undefined },
			replace: true,
		});
	},
});
